module.exports = __webpack_public_path__ + "img/rqtj@2x.83e8f379.png";